import axios from 'axios'
import store from '../store'

// 添加请求拦截器，在每次请求之前都会先走这个方法
axios.interceptors.request.use(config => {
  let tokenInSession = sessionStorage.getItem('token')
  let tokenStr = store.getters.getToken.token
  // 将 token 设置到请求头中
  if (tokenStr === '') {
    config.headers.common['token'] = tokenInSession
  } else {
    config.headers.common['token'] = tokenStr
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 添加响应拦截器，在每次请求得到响应之后都会先走这个方法
axios.interceptors.response.use(response => {
  // 在返回体的 header 中获取到后端返回的 token
  if (response.headers.token != null) {
    // 获取最新的token，存储到本地
    store.dispatch('asyncUpdateToken', {token: response.headers.token})
  }
  return response
}, error => {
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/config/axios.js